module.exports = __webpack_public_path__ + "img/sa.acf6c233.svg";